import { atom } from "recoil"
import { User } from "../types";

const userState = atom({
    key: 'userState',
    default: {} as User,
});

export default userState;
